<template>
  <div class="project-status-or-retry">
    <!-- Default view: the status badge (hidden on row hover). -->
    <project-status :item="item" />
    <!-- Hover view: stop (in-progress) or retry (canceled/failed), shown in place of the badge. -->
    <project-scan-action-table-cell
      v-if="hasAction"
      :item="item"
      :column="column"
      @displayError="$emit('displayError', $event)"
    />
  </div>
</template>

<script>
import { projectStatuses } from '@/constants/projects';
import ProjectStatus from '@/components/ProjectDetails/ProjectStatus.vue';
import ProjectScanActionTableCell from '@/components/tableCells/ProjectScanActionTableCell.vue';

export default {
  name: 'ProjectStatusOrRetryTableCell',
  components: { ProjectStatus, ProjectScanActionTableCell },
  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
  },
  computed: {
    hasAction() {
      return [
        projectStatuses.IN_PROGRESS,
        projectStatuses.REPEAT_IN_PROGRESS,
        projectStatuses.CANCELED,
        projectStatuses.FAILED,
      ].includes(this.item.status) && !!this.item.id;
    },
  },
};
</script>

<style lang="scss" scoped>
.project-status-or-retry {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
